// import WorkdayLogs from "pages/WorkdayLogs/Workdaylogs";

export const companyName = 'iLearningEngines'
export const companyFullName = 'iLearningEngines, Inc.';
export const companyShortName = 'iLE';

export const apiUrlDomain =
  process.env.REACT_APP_API_URL_DOMAIN ||
  process.env.LMS_BASE_URL ||
  'http://localhost:8081';

// Dedicated API base URL for AI proctoring (used by proctor-spa socket connections)
// In production, set this to the public API origin, e.g. 'https://lmsdev.aaisolutions.dev'
// export const proctorApiBaseUrl = 'https://lmsdev.aaisolutions.dev'; // TODO: move to env and override per environment
export const SSOUrlDomain = 'https://ssodev.aaisolutions.dev';
// export const jitsiDomain = 'meet.jit.si'
// export const jitsiDomain = '65.2.119.23'
// export const jitsiDomain = '65.1.120.31'
export const jitsiDomain = '13.126.99.194'

export const proctorOrigin = 'https://lmsdev.aaisolutions.dev:3001';

export const apiUrlBase = '/api/';
export const apiVersion = '0.2'

export const loginUrl = '/login';
export const forgotPasswordUrl = '/forgotpassword';
export const memberUrl = '/';
export const traineeUrl = '/trainee';

export const botAdminUrl = 'http://demo1.ilearningengines.com';
export const ileUrl = 'https://www.ilearningengines.com';
export const graphUrlPath = 'graphql';

export const defaultScorm = false;
export const encryptionKey = "pfv857p8904ufp0ra03fu67rowifsdvbsDUfh/ljk/24u534h";
// Display a Tooltip only when the user has hovered for at least
// 700 milliseconds
export const tooltipDelayMsecs = 700;

// Number of milliseconds by which to delay Fade transitions
export const defaultFadeInDelay = 300;
export const defaultFadeOutDelay = 300;

// Length of Fade transitions (in milliseconds)
export const defaultFadeInInterval = 300;
export const defaultFadeOutInterval = 300;


export const defaultFieldWidth = 9;

export const maxFieldLength = 100;
export const maxUrlLength = 2000;
export const maxDescriptionLength = 2000;
export const maxLNameLength = 50;
export const maxLShortNameLength = 20;
export const maxMShortNameLength = 100;
export const maxVideoTranscriptLength = 100000;
export const maxQuestionTextLength = 1000;
export const maxAnswerTextLength = 500;
export const maxAnswerCommentLength = 2000;
export const subjectFlyoutLimitValue = 7;

export const smallPanelWidth = 6;
export const mediumPanelWidth = 8;

export const minPasswordLength = 8;
export const maxPasswordLength = 80;

export const defaultStayLoggedIn = true;

// Periodically notify other windows of activity in the current window
export const idleDebounceMillis = 2000;
export const maxIdleMinutes = 12;
export const idleWarningMinutes = 2;

export const authTokenLifetimeMinutes = 30;
export const apiRequestTimeoutSecs = 30;
export const authTokenRetryIntervalSecs = 30;
export const minAuthTokenRetries = 5;
export const refreshAuthTokenIntervalSecs =
  60 * (authTokenLifetimeMinutes - maxIdleMinutes)
  - minAuthTokenRetries * (apiRequestTimeoutSecs + authTokenRetryIntervalSecs);


export const extVideoSources = [
  '//www.youtube.com/',
  '//youtube.com/',
  '//youtu.be/',
  '//www.facebook.com/',
  '//facebook.com/',
  '//www.soundcloud.com/',
  '//soundcloud.com/',
  '//www.vimeo.com/',
  '//vimeo.com/',
  '//www.twitch.tv/',
  '//twitch.tv/',
  '//www.streamable.com/',
  '//streamable.com/',
  '//home.wistia.com/',
  '//www.dailymotion.com/',
  '//dailymotion.com/',
  '//www.mixcloud.com/',
  'mixcloud.com/',
  '//player.vimeo.com/',
  'youtube.com/',
  '//www.loom.com/'
];

// Refresh the side menu twice a minute
export const sideMenuRefreshIntervalSecs = 20;

export const moduleTimePollingInterval = 10000;

export const faceIdLogin = false;

export const maxFaceAuthLoginRetryAttempts = 1;

export const insLinks = {
  logout:
    "/Shibboleth.sso/Logout?return=https://auth.ins.ilearningengines.com/idp/profile/Logout",
  login: "/Shibboleth.sso/Session",
  signout: "/saml2/signout",
};

export const memberSubmenuE = {
  CURRICULA: 1,
  MESSAGES: 5,

  DASHBOARD: 405,

  SITE: 101,
  CAMPUS: 102,
  SCHOOL: 103,
  GROUP_OF_INSTITUTE: 104,
  ACADEMIC_YEAR: 105,
  STANDARD: 106,
  SETTINGS: 107,
  DIVISION: 108,
  GROUP: 109,

  MEMBER: 111,
  SME_USER: 112,
  ADMIN_USER: 113,

  SYLLABUS: 121,
  CURRICULUM: 122,
  CHAPTER: 123,
  MODULE: 124,

  CLASS: 131,
  CLASS_LIST: 132,
  CLASS_VIEWER: 133,
  VIRTUAL_CLASS: 134,
  VIRTUAL_SESSION: 135,
  AI_QUEST_PAPER: 136,
  AI_CLASS_PERFORM: 137,

  TEST: 141,
  QUESTION_BANK: 151,

  PUBLISH_TEST: 161,

  ASSESSMENT_LIST: 171,

  HOME: 165,
  ASSESSMENT: 166,
  SUBJECT: 167,


  AI_LINK: 200,
  ANALYTICS: 300,

  EXTERNAL_CONTENT: 128,
  CURRVIEW: 301,
  TRAINEE_LANDING: 302,

  STUDENT_TEST: 129,
  SESSION: 303,
  ROOM: 304,
  LIVE_SESSIONS: 305,
  TRAINING_ZONE: 306,
  ATTENDANCE: 307,
  SHELF: 308,
  VIEW_SHELF: 309,
  STUDENT_VIEWSHELF: 339,
  GDRIVE: 310,

  MENU: 311,
  ROLE: 312,
  AIBOT: 313,
  AICONFIG: 314,
  REPORTS: 315,
  REPORTS1: 316,
  REPORTS2: 317,
  REPORTS3: 318,
  REPORTS4: 327,
  REPORTS5: 329,
  REPORTS6: 328,
  REPORTS7: 330,
  REPORTS8: 331,
  REPORTS9: 332,
  REPORTS10: 333,
  REPORTS11: 334,
  REPORTS12: 335,
  REPORTS13: 348,  /*For PODAR only */
  REPORTS14: 338,
  REPORTS20: 345,
  REPORTS22: 349,
  REPORTS23: 350,
  REPORTS24: 351,
  REPORTS25: 352,
  REPORTS26: 353,
  REPORTS27: 373,
  REPORTS28: 381,
  REPORTS29: 382,
  REPORTS30: 390,
  REPORTS31: 391,
  REPORTS32: 393,
  REPORTS33: 394,
  REPORTS34: 403,
  REPORTS35: 399,
  REPORTS36: 411,
  COURSE_PUBLISH: 181,
  COURSE: 319,
  COURSE_PUBL_VWR: 320,
  PROMOTION: 321,
  PLAYBACK: 322,
  PLAYBACK_STUDENT: 323,
  JOIN: 324,

  TEMPLATES: 325,
  CALENDAR: 326,
  PARENT: 347,
  GRADE: 354,
  REPORTS_POWERBI07: 363,
  REPORTS_POWERBI08: 364,
  REPORTS_POWERBI09: 365,
  REPORTS_POWERBI10: 366,
  REPORTS_POWERBI11: 367,
  REPORTS_POWERBI12: 368,
  REPORTS_POWERBI13: 369,
  REPORTS_POWERBI14: 370,
  REPORTS_POWERBI15: 371,
  ZONE: 362,
  DIFFICULTY_LEVEL: 372,
  REPORTS_POWERBI16: 374,
  REPORTS_POWERBI17: 377,
  LANGUAGE: 380,
  BOTS: 378,
  MEDIA_CONVERT: 379,
  ATTENDANCE_TRACKER: 387,
  TRACKER: 388,
  VIEWER: 389,
  OLD_COURSES: 386,
  COURSE_PUBLISH_STATUS: 392,
  SURVEY: 395,
  CREATE_SURVEY: 396,
  PUBLISH_SURVEY: 397,
  STUDENT_SURVEY: 400,
  EMBEDDED_REPORTS: 401,
  DISTRICT_WISE_REPORT: 402,
  ORGANISATIONAL_ANALYSIS_REPORT: 404,
  CERTIFY_BADGE: 405,
  CONFIGURATION: 406,
  CERTIFICATE_BADGE: 407,
  REPORTS_POWERBI18: 398,
  ACHIEVEMENTS: 408,
  CERTIFICATE_CONFIGURATION: 409,
  WORKDAY_LOGS: 410,
  CAMPAIGN: 412,
  EVENTS: 413,
  RATING: 414,
  MyCOURSE: 420,
  HELP_DESK: 418,
  RUBRICS: 415,
  CREATE_RUBRICS: 416,
  PUBLISH_RUBRICS: 417,
  STUDENT_RUBRICS: 424,
  RUBRICS_TYPE: 419,
  ATTENDANCE_MANAGEMENT: 425,
  FEE_MANAGEMENT: 427,
  TIME_TABLE:429,
  ATTENDENCE_RECORD: 426,
  EVENTS_AND_ANNOUNCEMENT:438,
  CLASS_ATTENDENCE:439,
  TASKS:440,

};

export const memberSubmenus = [
  memberSubmenuE.CURRICULA,
  memberSubmenuE.MESSAGES,
  memberSubmenuE.DASHBOARD,
  memberSubmenuE.GROUP_OF_INSTITUTE,
  memberSubmenuE.SCHOOL,
  memberSubmenuE.CAMPUS,
  memberSubmenuE.SITE,
  memberSubmenuE.ACADEMIC_YEAR,
  memberSubmenuE.MEMBER,
  memberSubmenuE.SME_USER,
  memberSubmenuE.ADMIN_USER,
  memberSubmenuE.CURRICULUM,
  memberSubmenuE.MODULE,
  memberSubmenuE.SYLLABUS,
  memberSubmenuE.CHAPTER,
  memberSubmenuE.CLASS,
  memberSubmenuE.CLASS_LIST,
  memberSubmenuE.CLASS_VIEWER,
  memberSubmenuE.VIRTUAL_CLASS,
  memberSubmenuE.VIRTUAL_SESSION,
  memberSubmenuE.AI_LINK,
  memberSubmenuE.AI_QUEST_PAPER,
  memberSubmenuE.AI_CLASS_PERFORM,
  memberSubmenuE.ANALYTICS,
  memberSubmenuE.STANDARD,
  memberSubmenuE.DIVISION,
  memberSubmenuE.SETTINGS,
  memberSubmenuE.GROUP,
  memberSubmenuE.ASSESSMENT,
  memberSubmenuE.TEST,
  memberSubmenuE.QUESTION_BANK,
  memberSubmenuE.PUBLISH_TEST,
  memberSubmenuE.LABEL,
  memberSubmenuE.EXTERNAL_CONTENT,
  memberSubmenuE.CURRVIEW,
  memberSubmenuE.TRAINEE_LANDING,
  memberSubmenuE.HOME,
  memberSubmenuE.ASSESSMENT,
  memberSubmenuE.SUBJECT,
  memberSubmenuE.STUDENT_TEST,
  memberSubmenuE.ASSESSMENT_LIST,
  memberSubmenuE.SESSION,
  memberSubmenuE.ROOM,
  memberSubmenuE.LIVE_SESSIONS,
  memberSubmenuE.TRAINING_ZONE,
  memberSubmenuE.ATTENDANCE,
  memberSubmenuE.SHELF,
  memberSubmenuE.STUDENT_VIEWSHELF,
  memberSubmenuE.VIEW_SHELF,
  memberSubmenuE.GDRIVE,
  memberSubmenuE.MENU,
  memberSubmenuE.ROLE,
  memberSubmenuE.AIBOT,
  memberSubmenuE.AICONFIG,
  memberSubmenuE.REPORTS,
  memberSubmenuE.REPORTS1,
  memberSubmenuE.REPORTS2,
  memberSubmenuE.REPORTS3,
  memberSubmenuE.REPORTS4,
  memberSubmenuE.REPORTS5,
  memberSubmenuE.REPORTS6,
  memberSubmenuE.REPORTS7,
  memberSubmenuE.REPORTS8,
  memberSubmenuE.REPORTS9,
  memberSubmenuE.REPORTS10,
  memberSubmenuE.REPORTS11,
  memberSubmenuE.REPORTS12,
  memberSubmenuE.REPORTS13, /*For PODAR only */
  memberSubmenuE.REPORTS14,
  memberSubmenuE.REPORTS20,
  memberSubmenuE.REPORTS22,
  memberSubmenuE.REPORTS23,
  memberSubmenuE.REPORTS24,
  memberSubmenuE.REPORTS25,
  memberSubmenuE.REPORTS26,
  memberSubmenuE.REPORTS27,
  memberSubmenuE.REPORTS28,
  memberSubmenuE.REPORTS29,
  memberSubmenuE.REPORTS30,
  memberSubmenuE.REPORTS31,
  memberSubmenuE.REPORTS32,
  memberSubmenuE.REPORTS33,
  memberSubmenuE.REPORTS34,
  memberSubmenuE.REPORTS35,
  memberSubmenuE.REPORTS36,
  memberSubmenuE.COURSE_PUBLISH,
  memberSubmenuE.COURSE,
  memberSubmenuE.COURSE_PUBL_VWR,
  memberSubmenuE.PROMOTION,
  memberSubmenuE.PLAYBACK,
  memberSubmenuE.JOIN,
  memberSubmenuE.PLAYBACK_STUDENT,
  memberSubmenuE.TEMPLATES,
  memberSubmenuE.CALENDAR,
  memberSubmenuE.PARENT,
  memberSubmenuE.GRADE,
  memberSubmenuE.DIFFICULTY_LEVEL,
  memberSubmenuE.WORKDAY_LOGS,
  memberSubmenuE.POWERBI_REPORTS,
  memberSubmenuE.REPORTS_POWERBI07,
  memberSubmenuE.REPORTS_POWERBI08,
  memberSubmenuE.REPORTS_POWERBI09,
  memberSubmenuE.REPORTS_POWERBI10,
  memberSubmenuE.REPORTS_POWERBI11,
  memberSubmenuE.REPORTS_POWERBI12,
  memberSubmenuE.REPORTS_POWERBI13,
  memberSubmenuE.REPORTS_POWERBI14,
  memberSubmenuE.REPORTS_POWERBI15,
  memberSubmenuE.ZONE,
  memberSubmenuE.REPORTS_POWERBI16,
  memberSubmenuE.REPORTS_POWERBI17,
  memberSubmenuE.LANGUAGE,
  memberSubmenuE.BOTS,
  memberSubmenuE.MEDIA_CONVERT,
  memberSubmenuE.MEDIA_CONVERT,
  memberSubmenuE.ATTENDANCE_TRACKER,
  memberSubmenuE.TRACKER,
  memberSubmenuE.VIEWER,
  memberSubmenuE.OLD_COURSES,
  memberSubmenuE.COURSE_PUBLISH_STATUS,
  memberSubmenuE.SURVEY,
  memberSubmenuE.CREATE_SURVEY,
  memberSubmenuE.PUBLISH_SURVEY,
  memberSubmenuE.STUDENT_SURVEY,
  memberSubmenuE.SURVEY_LIST,
  memberSubmenuE.EMBEDDED_REPORTS,
  memberSubmenuE.DISTRICT_WISE_REPORT,
  memberSubmenuE.ORGANISATIONAL_ANALYSIS_REPORT,
  memberSubmenuE.CERTIFY_BADGE,
  memberSubmenuE.CONFIGURATION,
  memberSubmenuE.CERTIFICATE_BADGE,
  memberSubmenuE.CERTIFICATE_CONFIGURATION,
  memberSubmenuE.ACHIEVEMENTS,
  memberSubmenuE.HELP_DESK,
  memberSubmenuE.CAMPAIGN,
  memberSubmenuE.EVENTS,
  memberSubmenuE.RATING,
  memberSubmenuE.MyCOURSE,
  memberSubmenuE.RUBRICS,
  memberSubmenuE.CREATE_RUBRICS,
  memberSubmenuE.PUBLISH_RUBRICS,
  memberSubmenuE.STUDENT_RUBRICS,
  memberSubmenuE.RUBRICS_TYPE,
  memberSubmenuE.ATTENDANCE_MANAGEMENT,
  memberSubmenuE.FEE_MANAGEMENT,
  memberSubmenuE.TIME_TABLE,,
  memberSubmenuE.ATTENDENCE_RECORD,
   memberSubmenuE.EVENTS_AND_ANNOUNCEMENT,
    memberSubmenuE.CLASS_ATTENDENCE,
    memberSubmenuE.TASKS,
];

export const screenSteps = {
  [memberSubmenuE.MODULE]: [
    [
      {
        step: 0,
        element: "#entity-form-tabs-tab-0",  //1
        intro: "General Tab",
      },
      {
        step: 1,
        element: ".intro-general-tab",
        intro: "Here, you can enter the basic details of the module",  //2
        title: 'General Tab'
      },
      {
        step: 2,
        element: ".intro-module-name",  //3
        intro: "Module Name should be entered here",
      },
      {
        step: 3,
        element: ".intro-standard",  //4
        intro: "You can choose the standard for which the module is being made using this drop-down",
      },
      {
        step: 4,
        element: ".intro-subject",  //5
        intro: "You can choose the subject for which the module is being made using this drop-down",
      },
      {
        step: 5,
        element: ".intro-short-name",  //6
        intro: "The short name is auto-generated",
      },
      {
        step: 6,
        element: ".intro-module-modifiable",  //7
        intro: "Other teachers can modify this module if the box is checked",
      },
      {
        step: 7,
        element: ".intro-module-viewable",  //8
        intro: "The module will be visible to other teachers if the box is checked",
      },
      {
        step: 8,
        element: ".intro-description-textarea",
        intro: "You can give a brief description of the module in this text area",
      },
      {
        step: 9,
        element: ".intro-image",
        intro: "You can upload an image as a module cover picture. This is optional.",
      },
      {
        step: 10,
        element: ".module-content-left-box",
        intro: "You can choose the content format here",
      },
      {
        step: 11,
        element: '.question-table',
        intro: 'Add in-course questions here'
      }
    ],
    [9, 10, 11]                              // mention last step number in each tab
  ],
  [memberSubmenuE.CHAPTER]: [
    [
      {
        element: ".intro-chapter-name",
        intro: "Chapter Name should be entered here",
      },
      {
        element: ".intro-add-modules",
        intro: "Chapter Name should be entered here",
      },
    ],
    [0]
  ],
  [memberSubmenuE.ROOM]: [
    [
      {
        element: ".entity-field-permission-true",
        intro: "Insert steps here",
      },
      {
        element: ".intro-division-select",
        intro: "Keep this open so that all class can see this virtual room",
      },
    ],
    [0]
  ]

};

export const userTracking = {
  // ANALYTICS: {
  //   isAnalyticsTracking: false,
  //   graphqlCallInterval: 5 * 60 * 1000, //minutes*60*1000
  //   studyMapTriggerInterval: 20 * 1000, //seconds*1000
  //   idleTimeoutInterval: 3 * 60 * 1000 //seconds*1000
  // },
  COUNTLY: false
}

export const reports = {
  TRAINER: false,
  TRAINEE: false
}

export const contentStatusE = {
  UNAVAILABLE: 0,
  NEW: 1,
  UNVIEWED: 2,
  IN_PROGRESS: 3,
  COMPLETED: 4,
  REVIEWING: 5,
};

// Category type levels

export const showBrandLogo = true;

export const categoryLevelE = {
  JUNIOR: 1,
  PRIMARY: 2,
  SECONDARY: 3,
  HIGHERSECONDARY: 4
}

export const categoryLevels = {
  [categoryLevelE.JUNIOR]: 'Junior',
  [categoryLevelE.PRIMARY]: 'Primary',
  [categoryLevelE.SECONDARY]: 'Secondary',
  [categoryLevelE.HIGHERSECONDARY]: 'Senior Secondary',
  // [categoryLevelE.MIDDLE]:  'Middle',
};

// Minimum factor by which we should scale the font size of the curriculum
// title so the entire header (title + credits) fits on one line
export const minCurriculumTitleScaleFactor = 0.8;

// Default number of milliseconds after the last window resize event before
// handling the event
export const defaultResizeDebounceIntervalMillis = 100;

// Number of milliseconds after the last window resize event before updating
// the curriculum notes layout
export const curriculumNotesResizeDebounceMillis = 50;

// Number of milliseconds after the last change to a search field input
// before updating the search results
export const searchFormDebounceMillis = 500;

// Minimum screen width (in pixels) for which the player will display
// multiple panes simultaneously
export const minMultiPanePlayerWidth = 4000; //1280; -- to make only single pane

// When a PDF is initially displayed, the maximum fraction of the page which
// can occupy the entire height of the player window (any larger fraction will
// cause the page to be shrunk to fit the window)
export const maxPdfInitVisibleHeightFrac = 0.75;

// Increase the scale by 25% when zoom in, decrease it 20% when zoom out
export const playerZoomStep = 1.25;

export const minPlayerZoomFactor = -3;
export const maxPlayerZoomFactor = 5;

export const pdfCropPaddingPercent = 5;

// To display only a subset of a PDF page, make the region preceding the subset
// partially opaque, but blank out the region following it
export const pdfTopMaskOpacity = 0.7;
export const pdfBottomMaskOpacity = 1;

export const ConfigurationTarget = {
  AWS: 1,
  Local: 2,
};

export const settingsConfigurationTarget = {
  [ConfigurationTarget.AWS]: 'AWS',
  [ConfigurationTarget.Local]: 'Local',
};

export const testQuestionTypeQBE = { //QuestionBank
  ASSIGNMENT: 4,
  FILL_IN_THE_BLANK: 1,
  MULTIPLE_CHOICE: 0,
  MULTIPLE_CHOICE_SINGLE: 6,
  COMMENT: 3,
  // FILL_IN_THE_BLANK: 1,
  // // SURVEY_MULTIPLE_CHOICE: 2,
  // COMMENT: 3,
  // ASSIGNMENT: 4,
  // // MATCH_THE_FOLLOWING: 5,
  // MULTIPLE_CHOICE_SINGLE: 6,
};

export const testQuestionTypeQBNames = {
  [testQuestionTypeQBE.MULTIPLE_CHOICE]: 'multipleChoice',
  [testQuestionTypeQBE.FILL_IN_THE_BLANK]: 'fillInTheBlanks',
  // [testQuestionTypeQBE.SURVEY_MULTIPLE_CHOICE]: 'Survey (multiple choice)',
  [testQuestionTypeQBE.COMMENT]: 'shortAnswer',
  [testQuestionTypeQBE.ASSIGNMENT]: 'assignment',
  // [testQuestionTypeQBE.MATCH_THE_FOLLOWING]: 'Match Answers to Questions',
  [testQuestionTypeQBE.MULTIPLE_CHOICE_SINGLE]: 'multipleChoiceSingleOption',
};

export const testQuestionTypeE = {
  FILL_IN_THE_BLANK: 1,
  MULTIPLE_CHOICE: 0,
  //FILL_IN_THE_BLANK: 1,
  // SURVEY_MULTIPLE_CHOICE: 2,
  COMMENT: 3,
  // ASSIGNMENT: 4,
};

export const testQuestionColors = {
  [testQuestionTypeE.MULTIPLE_CHOICE]: '#65a095',
  [testQuestionTypeE.FILL_IN_THE_BLANK]: '#0e800e',
  [testQuestionTypeE.SURVEY_MULTIPLE_CHOICE]: '#ea788b',
  [testQuestionTypeE.COMMENT]: '#de780c',
}

export const testQuestionTypeNames = {
  [testQuestionTypeE.MULTIPLE_CHOICE]: 'multipleChoice',
  [testQuestionTypeE.FILL_IN_THE_BLANK]: 'fillInTheBlanks',
  [testQuestionTypeE.SURVEY_MULTIPLE_CHOICE]: 'Survey (multiple choice)',
  [testQuestionTypeE.COMMENT]: 'Comment',
  [testQuestionTypeQBE.ASSIGNMENT]: 'Assignment'
};

export const curriculumShowMoreSortList = [
  { value: 'end_date', label: "endDate" },
  { value: 'name', label: "name" },
  { value: 'progress', label: "progress" },
  { value: 'start_date', label: "startDate" },

];
export const curriculumSortList = [
  { value: 'modules', label: "module" },
  { value: 'progress', label: "progress" },
  { value: 'sequence', label: "sequence" },
  { value: 'title', label: "title" },

];
export const scheduleCalenderType = [
  { value: '0', label: "Day" },
  { value: '1', label: "Week" },
  { value: '2', label: "Month" },
  { value: '3', label: "Year" }
];
export const scheduleCalender = [
  { value: '0', label: "doesNotRepeat" },
  { value: '1', label: "everyWeek" },
  { value: "2", label: "daily" },
  { value: "3", label: "weekly" },
  { value: "4", label: "monthly" },
]

export const scheduleMonthWeek = [
  { value: 'first', label: "First" },
  { value: 'second', label: "Second" },
  { value: "third", label: "Third" },
  { value: "fourth", label: "Fourth" },
  { value: "last", label: "Last" },
]

export const scheduleMonthWeekDay = [
  { value: 'monday', label: "Monday" },
  { value: 'tuesday', label: "Tuesday" },
  { value: "wednesday", label: "Wednesday" },
  { value: "thursday", label: "Thursday" },
  { value: "friday", label: "Friday" },
  { value: "saturday", label: "Saturday" },
  { value: "sunday", label: "Sunday" },
]

export const liveSessionSortList = [
  { value: 'name', label: "name" },
  { value: 'subject', label: "program" }
];

export const livesessionFilterList = [
  { value: 'ended', label: "ended" },
  { value: 'inactive', label: "inActive" },
  { value: 'started', label: "started" },

];

export const curriculumFilterList = [
  { value: 'completed', label: "completed" },
  { value: 'progress', label: "inProgress" },
  { value: 'new', label: "new" },
];
export const curriculumShowMoreFilterList = [
  { value: 'completed', label: "completed" },
  { value: 'expired', label: "expired" },
  { value: 'progress', label: "inProgress" },
  { value: 'new', label: "new" },
  { value: 'Yet To Start', label: "yetToStart" },
];
export const assessmentSortList = [
  { value: 'end', label: "endDate" },
  { value: 'name', label: "name" },
  { value: 'subject', label: "program" },
  { value: 'start', label: "startDate" },

];

export const assessmentFilterList = [
  { value: 'attended', label: "Attended" },
  { value: 'closed', label: "Closed" },
  { value: 'inprogress', label: "In Progress" },
  { value: 'yettostart', label: "Yet To Start" },
  { value: 'all', label: "All" },
];

export const usedQuestionFilterList = [
  { value: 'all', label: "all" },
  { value: 'new', label: "new" },
  { value: 'used', label: "used" },

];

export const screenName = [
  // {value: 'all' , label: "All" },
  { value: 'student', label: "student" },
  { value: 'teacher', label: "teacher" },
  { value: 'admin', label: "administrator" },
  { value: 'sub', label: "subject" },
  { value: 'mod', label: "module" },
  { value: 'chap', label: "chapter" },
  { value: 'qb', label: "questionbank" },
  // {value: 'goi' , label: "GOI" },
  // {value: 'school' , label: "School" },
  // {value: 'org' , label: "Organization" },
  // {value: '' , label: "" },
  // {value: '' , label: "" },

]

export const userType = [
  { value: '1', label: "Student" },
  { value: '2', label: "Teacher" },
  { value: '3', label: "Administrator" }
]
export const timePeriod = [
  { value: '1', label: "1 Week" },
  { value: '2', label: "1 Month" },
  { value: '3', label: "3 Month" },
  { value: '4', label: "6 Month" }

]
export const emailTemplate = [
  { value: '4', label: "Student Account Creation" },
  { value: '5', label: "Teacher/ Admin Account Creation" },
  { value: '6', label: "Course Publish" },
  { value: '7', label: "Assessment Publish" },
  { value: '8', label: "Course Reminder" },
  { value: '9', label: "Assessment Reminder" },
  { value: '10', label: "Student Batch Allocation" },
  { value: '11', label: "Event Creation" },
  { value: '3', label: "Forgot Password" },
  { value: '12', label: "Monthly Student Report" },
  { value: '13', label: "Ticket Escalation" },
]
export const dayOrder = [
  { value: '1', label: "I" },
  { value: '2', label: "II" },
  { value: '3', label: "III" },
  { value: '4', label: "IV" },
  { value: '5', label: "V" },
  { value: '6', label: "VI" },
  { value: '7', label: "Holiday" }
]
export const unit = [
  { value: '1', label: "I" },
  { value: '2', label: "II" },
  { value: '3', label: "III" },
  { value: '4', label: "IV" },
  { value: '5', label: "V" },
  { value: '6', label: "VI" },
  { value: '7', label: "VII" },
  { value: '8', label: "VIII" },
  { value: '9', label: "IX" },
  { value: '10', label: "X" }
]

export const timePeriodName = [
  { value: '1', label: "I st Hour" },
  { value: '2', label: "II nd Hour" },
  { value: '3', label: "III rd Hour" },
  { value: '4', label: "IV th Hour" },
  { value: '5', label: "V thHour" },
  { value: '6', label: "VI th Hour" },
  { value: '7', label: "VII th Hour" },
  { value: '8', label: "VIII th Hour" }
]

export const classPeriods = [
  { value: '1', label: "I" },
  { value: '2', label: "II" },
  { value: '3', label: "III" },
  { value: '4', label: "IV" },
  { value: '5', label: "V" },
  { value: '6', label: "VI" },
  { value: '7', label: "VII" },
  { value: '8', label: "VIII" }
]

export const jobStatus = [
  { value: 'new', label: "new" },
  { value: 'running', label: "running" },
  { value: 'complete', label: "complete" }
]

// Minimum document width and height (in pixels) for which a quiz
// QuestionForm is rendered using two columns
export const twoColQuestionFormMinBodyWidth = 768;
export const twoColQuestionFormMinBodyHeight = 600;

// Chat messages are limited to 1000 characters
export const maxChatMessageLength = 1000;
export const chatMessagePlaceholder =
  `Your message here (maximum of ${maxChatMessageLength} characters)`;

// Chat message previews are limited to 40 characters
export const maxChatPreviewLength = 40;

// Refresh messages once a minute
export const chatRefreshIntervalSecs = 20;

// Throttle interval for recording in the db which messages have been viewed
export const chatViewedUpdateIntervalSecs = 60;

// Minimum document width (in pixels) for which a wide chat thread table
// can be displayed
export const wideChatThreadTableMinBodyWidth = 992;

// Minimum document height (in pixels) for which the chat thread table
// and active thread can be simultaneously displayed
export const splitChatViewMinBodyWidth = 500;

// Wait 250 milliseconds after the last window resize event before updating
// the layout of the chat panes
export const chatResizeDebounceMillis = 250;

// Test comments are limited to 1000 characters
export const testCommentPlaceholder = 'Your comment here';
export const maxTestCommentLength = 1000;

export const testAnswerPlaceholder = 'Your answer here';
export const maxTestAnswerLength = 100;
export const maxFillInTheBlankErrorRate = 0.35;

export const testExplanationFadeInDelay = 500;
export const testExplanationFadeInInterval = 2000;

// Unmount the explanation immediately so the next question's
// explanation is not briefly visible
export const testExplanationFadeOutDelay = 0;
export const testExplanationFadeOutInterval = 0;

// We require greater contrast for a light theme (dark characters on a light
// background) than for a dark theme
export const minLightThemeBgLightness = 67;
// Polling interval (in seconds) for checking the status of a SCORM course
// insertion
export const scormCourseInsertStatusPollInterval = 1;

//Polling interval (in seconds) for checking status of Vimeo upload transcoding to get duration
export const vimeoUploadTranscodePollInterval = 10;

// Maximum pdf size (in bytes) 10*1024*1024;
export const maxPdfSize = 10485760;

// Maximum audio size (in bytes) 30*1024*1024;
export const maxAudioSize = 31457280;

// Maximum video size (in bytes)
export const maxVideoSize = 100 * 1024 * 1024;

// Maximum image size (in bytes)
export const maxImageSize = 2097152; //2*1024*1024

// Maximum image size (virtual room card)
export const maxImageWidth = 292;

// Maximum image size (virtual room card)
export const maxImageHeight = 130;

// Maximum convert size (in bytes)
export const maxConvertSize = 1610612736;

export const surveyQuestionOptions = [
  { value: "0", label: "Multiple choice questions" },
  { value: "1", label: "Short Answer Type" },
  { value: "2", label: "StarType Questions" },
];

export const surveyAnswerOptions = [
  { value: "0", label: "Yes - No" },
  { value: "1", label: "Agree - Disagree" },
  { value: "2", label: "True - False" },
  { value: "3", label: "Others" },
];

export const ROUTES = {
  classAttendance: "/class-attendance",
  login: "/login",
  ssoLogin: "/sso-login",

  //COMMON
  pbiReports: "/pbireport",
  home: "/",
  // dashboard: "/dashboard",
  playback: "/playback",
  join: "/join",
  trainingZone: "/training-zone",
  trainingZoneContent: "/training-zone/content",
  knowledgeShelf: "/knowledge-shelf",
  createShelf: "/create-shelf",
  reports: "/reports",
  privacyPolicy: "/privacy-policy",
  termsOfUse: "/terms-of-use",
  trainingZoneContentExternal: "/training-zone-external",
  trainingZoneExternalContent: "/training-zone-external/content",
  chat: "/chat",
  directChat: "/direct-chat",
  contact: "/contact",
  profileSettings: "/profile-settings",
  viewShelfContent: "/view-shelf/content",
  subjectList: "/curricula",
  calendar: "/calendar",
  grade: "/grade",
  botCanvas: "/bot-canvas",
  canvasDocuments: "/canvas-documents",
  documentQuestions: "/document-questions",
  questionDetails: "/question-details",

  //STUDENT

  assessments: "/assessments",
  assessmentsLanding: "/assessments-summary",
  assessmentsAttend: "/attend",
  traineeCurriculum: "/content",
  traineeCardViewInner: "/contentInner",
  variants: "/variants",
  traineeSubscriptionSubject: "/curriculum/subscription",
  oldCourses: "/oldcourses",
  subscriptionPreview: "/subscription",
  studentSurvey: "/StudentSurvey",
  surveyRoute: "/SurveyRouter",
  surveyAttend: "/surveyAttend",
  surveyResponse: "/surveyResponse",
  surveyGeneral: "/surveyGeneral",
  assessmentSummaryDetails: "/assessments-summarydetails",
  surveyCard: "/surveyCard",
  StudentRubrics: "/StudentRubrics",
  StudentRubricDetails: "/student-rubrics/details",
  StudentRubricAttempt: "/student-rubrics/attempt",
  StudentRubricSummary: "/student-rubrics/summary",
  StudentRubricAttended: "/student-rubrics/attended",
  courseDetails: "/course-details",
  StudentRubricResponse:"/student-rubrics/response",
  studentFeePayment: "/fee-payment",
   alert:"/alert",

  //TEACHER
  class: "/class",
  subjects: "/subjects",
  modules: "/modules",
  chapters: "/chapters",
  courses: "/courses",
  coursePublish: "/course-publish",
  assessmentList: "/list",
  createTest: "/create-test",
  publishTest: "/publish-test",
  questionBank: "/question-bank",
  rooms: "/rooms",
  sessions: "/sessions",
  attendance: "/attendence",
  templates: "/templates",
  evaluateForm: "/evaluate-form",
  subjectProgress: "/progress",
  subjectProgressDetail: "/progress/detail",
  externalChannels: "/external-channels",
  externalChannelsContent: "/external-channels/content",
  courseClassList: "/class-list",
  chapterallocation: "/chapterallocation",
  addAttendance: "/attendance-tracker",
  publishSurvey: "/publish-survey",
  createSurvey: "/create-survey",
  surveyList: "/survey-list",
  ContentBuilder: "/content-builder",
  TestCreation: "/test-creation",
  trainerEvaluate: "/trainer-evaluate",
  MyCourse: "/mycourses",
  CourseDetails: "/coursedetails",
  MyCourseDetails: "/mycourse-details",
  Rubrics: "/create-rubrics",
  RubricsAssessment: "/Rubrics-assessment",
  CreateRubrics: "/create-rubrics",
  PublishRubrics: "/publish-rubrics",
  RubricsList: "/rubrics-list",
  rubricEvaluate: "/rubric-evaluate",
  questionEvaluation: "/question-evaluation",
  AttendenceRecord: "/Attendance-Record",
  Tasks: "/Tasks",
  CreateAssignment: "/Tasks/CreateAssignment",



  //ADMIN
  syllabus: "/syllabus",
  trainees: "/members",
  classList: "/classlist",
  trainers: "/trainers",
  admins: "/adminstrators",
  access: "/access",
  roles: "/roles",
  academicYears: "/academic-years",
  divisions: "/divisions",
  schools: "/schools",
  campuses: "/campuses",
  classes: "/classes",
  goi: "/goi",
  aiConfig: "/ai-configuration",
  aiBot: "/ai-bot",
  viewShelf: "/view-shelf",
  role: "/user-role",
  menu: "/menu",
  site: "/site",
  categories: "/categories",
  configuration: "/configuration",
  promotion: "/promotion",
  sessionsMeet: "/sessions/meet",
  parent: "/parent",
  parentZonePage: "/parent/zonepage",
  difficultyLevel: "/difficulty-level",
  zone: "/zone",
  language: "/language",
  mediaConvert: "/mediaconverter",
  tracker: "/tracker",
  attendanceTracker: "/attendance-tracker",
  coursePublishStatus: "/course-publish-status",
  viewerForm: "/viewer",
  studentDashboard: "/studentDashboard",
  StudentDashboard: "/StudentDashboard",
  achievementConfiguration: "/achievement-configuration",
  adminDashboard: "/admin-dashboard",
  campusDashboard: "/campus-dashboard",
  teacherAnalytics: "/teacher-analytics",
  classAnalytics: "/class-analytics",
  courseInsight: "/courseInsight",
  assessmentInsight: "/assessmentInsight",
  workdayLogs: "/workdayLogs",
  campaign: "/campaign",
  events: "/events",
  rating: "/rating",
  helpdesk: "/helpdesk",
  RubricsType: "/rubrics-type",
  AttendanceManagement: "/AttendanceManagement",
  FeeManagement: "/fee-management",
  TimeTable: "/time-table",
  Events:"/events-announcement"
}

export const noSidebarRoutes = [
  ROUTES.trainingZoneContent,
  ROUTES.trainingZoneExternalContent,
  ROUTES.traineeCurriculum,
  ROUTES.traineeCardViewInner,
  ROUTES.assessmentsAttend,
  ROUTES.externalChannelsContent,
  ROUTES.viewShelfContent,
  ROUTES.reports,
  ROUTES.subjectProgress,
  ROUTES.subjectProgressDetail,
  ROUTES.subscriptionPreview,
  ROUTES.playback,
  // ROUTES.subjectList
]
